export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
            关于7788电影网
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            7788电影网成立于2018年，致力于为中文影迷打造<strong className="text-foreground-900">一站式在线观影平台</strong>。
            我们收录了电影大全涵盖的动作、悬疑、喜剧、科幻等全类型高清电影资源，每日实时更新最新电影与热门电影片库。
            依托先进的<strong className="text-foreground-900">CDN加速与高清转码技术</strong>，确保每一位用户都能享受免费不缓冲的流畅观影体验。
            电影排行榜依据真实播放热度与用户评分实时生成，帮你从海量电影中快速发现好片。
            7788电影网始终坚守免费、高清、流畅三大原则，让看电影这件事变得简单又快乐。
          </p>
        </div>
      </div>
    </section>
  );
}